<template>
    <div>
      <LabdaqCompletedOrders></LabdaqCompletedOrders>
    </div>
  </template>
  
  <script>
  const LabdaqCompletedOrders = defineAsyncComponent(() =>
    import("@/components/cases/LabdaqCompletedOrders")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        LabdaqCompletedOrders,
    },
  };
  </script>
  